// extracted by mini-css-extract-plugin
module.exports = {"progeress-control-container":"index_progeress-control-container_2jO-H","progress-top":"index_progress-top_dRw6m","progress-main":"index_progress-main_1FpxC"};